import React, { useRef, useEffect, useState } from 'react';
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Checkbox } from 'primereact/checkbox';
import { Col, Row } from 'react-bootstrap';
import { Button } from 'primereact/button';

const TeacherNoteSave = ({ schoolClassId, courseId, onChange, onClose }) => {
    const [loading, setLoading] = useState(true);
    const [note, setNote] = useState({});
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [noteFormVisible, setNoteFormVisible] = useState(false);
    const [student, setStudent] = useState(null);
    const [noteNo, setNoteNo] = useState(0);
    const [score, setScore] = useState(0);
    const [scoreStr, setScoreStr] = useState("");
    const [scoreState, setScoreState] = useState(1);
    const [comment, setComment] = useState("");
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
    const [deleting, setDeleting] = useState(false);

    useEffect(() => {
      setLoading(true);
      var params = {login:util.getTrustedUser(), schoolClassId:schoolClassId, courseId:courseId};
      var url = config.Server+`/school/teacher/school-class/note/get`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response;
                  console.log("note resopnse is> ", response);
                  var n = {...response.data};
                  for(var i=0;i<n.students.length;i++){
                    n.students[i]["noteVisible"] = false;
                    var ss = 0;
                           
                    for(var j=0;j<n.students[i].notes.length;j++){
                        ss += (n.students[i].notes[j].zarib * n.students[i].notes[j].effectScore);
                    }
                    if(ss >=0) {
                        n.students[i].effectScoreSum = ss;
                        n.students[i].zarib = 1;
                    }
                    else{
                        n.students[i].effectScoreSum = ss * -1;
                        n.students[i].zarib = -1;
                    }
                  }
                  setNote(n);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  //setLoading(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              //setLoading(false);
          });
     
    }, []);

    const showStudentNotes = function(row, index){
        var n = {...note};
        n.students[index].noteVisible = !n.students[index].noteVisible;
        setNote(n);
    }
    const mainDialogFooter = function(){
        return (
            <Row className="justify-content-md-center" style={{ direction: "ltr", textAlign:"right" }}>
                <Col style={{textAlign:"rigth"}}>
                    <Button label="انصراف" icon="pi pi-times" outlined onClick={()=>onClose()} iconPos="right" />
                </Col>
            </Row>
        )
    }
    const noteDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{setNoteFormVisible(false)}} saving={saving} />
        )
    }
    const saveItem = function(){
        console.log("scoreState is>", scoreState)
        console.log("score is>", score)
        console.log("comment is>", comment)
        if(((scoreState == 1)||(scoreState == 2))&&(score <=0)){
            setErorVisible(true);
            setErrorMessage("نمره تنظیم نشده است");
            return;
        }
        if((scoreState == 3)&&(comment == "")){
            setErorVisible(true);
            setErrorMessage("نمره یا شرح هیچکدام تنظیم نشده است");
            return;
        }
      setSaving(true);
      var sc = score;
      var zarib = 1;
      if(scoreState == 2){
        zarib = -1;
      }
      else if(scoreState == 3){
        sc = 0;
      }
      var params = {login:util.getTrustedUser(), noteNo:noteNo, schoolClassId:schoolClassId, courseId:courseId, studentId:student.id, comment:comment, effectScore:sc, zarib:zarib};
      var url = config.Server+`/school/teacher/school-class/note/save`;
      console.log("save param is>", params);
      console.log("save url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              console.log("save response is>", response);
              if(response.state === "ok"){
                var n = {...response.data};
                for(var i=0;i<n.students.length;i++){
                    n.students[i]["noteVisible"] = false;
                    if(n.students[i].student.id == student.id)n.students[i]["noteVisible"] = true;
                }
                setNote(n);                
                onChange();
                setNoteFormVisible(false);                  
                setSaving(false);
              }
              else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
        
    }
    const onAddButtonClick = function(stu){
        setStudent(stu);
        setNoteNo(0);
        setNoteFormVisible(true);
    }
    const onEditButtonClick = function(stu, no, effectSc, zarib, cmnt){
        setStudent(stu);
        setNoteNo(no);
        setComment(cmnt);
        if(effectSc > 0){
            if(zarib == 1){
                setScoreState(1);
            }
            else{
                setScoreState(2);
            }
            setScore(effectSc);
            setScoreStr(String(effectSc));
        }
        else{
            setScoreState(3);
            setScoreStr("");
            setScore(0);
        }
        setNoteFormVisible(true);
    }
    const deleteItem = function(){
        setDeleting(true);
        var params = {login:util.getTrustedUser(), noteNo:noteNo, schoolClassId:schoolClassId, courseId:courseId, studentId:student.id};
        var url = config.Server+`/school/teacher/school-class/note/delete`;
            axios
                .post(url, params )
                .then(res => {
                var response = res.data;
                    if(response.state === "ok"){
                    var n = {...response.data};
                    for(var i=0;i<n.students.length;i++){
                        n.students[i]["noteVisible"] = false;
                        if(n.students[i].student.id == student.id)n.students[i]["noteVisible"] = true;
                    }
                    setNote(n);                
                    onChange();

                    setDeleting(false);
                    setConfirmDeleteVisible(false);
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setDeleting(false);
                }
                })
                .catch(error => {
                setDeleting(false);
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                });
    }
    const onDeleteConfirm_Accept = function(){
        deleteItem();
    }
    const onDeleteConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteVisible(false);
    }
    const onDeleteButtonClick = function(stu, no){
        setStudent(stu);
        setNoteNo(no);
        setConfirmDeleteVisible(true);
    }
    const createAddButton = function (student) {
        return (
            <div onClick={() => {onAddButtonClick(student)}} style={{position:"relative", display:"inline-block", textAlign:"center", float:"right", width:"32px", padding:"5px 0px 0px 0px", marginRight:"0px", border:"1px solid #b0b0b0", borderRadius:"5px", backgroundColor: "rgb(49, 113, 5)", color: "rgb(221, 240, 202)", cursor: "pointer"}}>
            <i class="bi bi-pencil-square"></i>
            </div>
        );
    }
    const createEditButton = function (stu, no, effectSc, zarib, cmnt) {
        return (
            <div onClick={() => {onEditButtonClick(stu, no, effectSc, zarib, cmnt)}} style={{position:"relative", display:"inline-block", textAlign:"center", float:"right", width:"32px", padding:"5px 0px 0px 0px", marginRight:"0px", border:"1px solid #b0b0b0", borderRadius:"5px", backgroundColor: "rgba(67, 29, 236, 1)", color: "rgba(210, 226, 250, 1)", cursor: "pointer"}}>
            <i class="bi bi-pencil-fill"></i>
            </div>
        );
    }
    const createDeleteButton = function (stu, no) {
        return (
            <div onClick={() => {onDeleteButtonClick(stu, no)}} style={{position:"relative", display:"inline-block", textAlign:"center", float:"right", width:"32px", padding:"5px 0px 0px 0px", marginRight:"0px", border:"1px solid #b0b0b0", borderRadius:"5px", backgroundColor: "rgba(226, 226, 226, 1)", color: "rgb(104, 99, 100)", cursor: "pointer"}}>
            <i class="bi bi-trash"></i>
            </div>
        );
    }
    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "comment") setComment(val);
        if(name == "score") {
            if(val == "") {
                setScore(0);
                setScoreStr("");
            }
            else{
                var v = parseFloat(val);
                if(v < 0) {
                    setScore(0);
                }
                else{
                    setScore(v);
                }
                setScoreStr(val);
            }
        }
    }
    const onCheckboxChange = (e, name) => {
        if(name == "positive"){
            setScoreState(1);
        }
        else if(name == "negative"){
            setScoreState(2);
        }
        else if(name == "none"){
            setScoreState(3);
        }
    }
    return (
        <>
        <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        header="ثبت یادداشت کلاسی" modal className="p-fluid" footer={() => mainDialogFooter()} onHide={() => onClose()}>
            {
                loading?
                <>
                    loding...
                    <br/>
                    <Skeleton />
                </>
                :
                <>
                    <table style={{width:"100%", borderCollapse:"collapse"}}>
                        <tbody>
                            <tr><td colSpan={2}>&nbsp;</td></tr>
                            <tr>
                                <td style={{padding:"3px",textAlign:"center", border:"1px solid #b0b0b0"}}>{note.schoolClass.name}</td>
                                <td style={{padding:"3px",textAlign:"center", border:"1px solid #b0b0b0"}}>{note.course.name}</td>
                            </tr>
                            <tr><td colSpan={2} style={{textAlign:"center"}}>برای ثبت یادادشت بر روی نام دانش آموز کلیک کنید</td></tr>
                            <tr><td colSpan={2}>&nbsp;</td></tr>
                        </tbody>
                    </table>

                    <table style={{width:"100%", borderCollapse:"collapse"}}>
                        <thead>
                            <tr>
                                <th style={{width:"20px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>#</th>
                                <th style={{backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0"}}>نام و نام خانوادگی</th>
                                <th style={{backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0"}}>کد ملی</th>
                                <th style={{width:"40px", backgroundColor:"#e5e5e5", fontWeight:"normal", fontSize:"8pt", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>جمع</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                note.students.map((row, index)=>{
                                    return(
                                    <>
                                    <tr style={{cursor:"pointer"}} onClick={()=>showStudentNotes(row, index)}>
                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{(index+1)}</td>
                                        <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.student.firstname + " " + row.student.lastname}</td>
                                        <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.student.nationalId}</td>
                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), color:row.zarib>=0?"rgba(20, 151, 20, 1)":"#F00", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                                            {row.effectScoreSum}
                                        </td>
                                    </tr>
                                    {
                                        row.noteVisible?
                                        <tr>
                                            <td colSpan={4}>
                                                <table style={{margin:"3px", width:"calc(100% - 6px"}}>
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan={4} style={{textAlign:"right", padding:"3px"}}>
                                                                {createAddButton(row.student)}
                                                            </td>
                                                        </tr>
                                                        <tr style={{backgroundColor:"#555", color:"#fff"}}>
                                                            <td style={{border:"1px solid #b0b0b0", textAlign:"right", padding:"3px"}}>شرح</td>
                                                            <td style={{border:"1px solid #b0b0b0", textAlign:"center", padding:"3px"}}>نمره</td>
                                                            <td style={{border:"1px solid #b0b0b0", textAlign:"right", padding:"3px", width:"40px"}}>&nbsp;</td>
                                                            <td style={{border:"1px solid #b0b0b0", textAlign:"right", padding:"3px", width:"40px"}}>&nbsp;</td>
                                                        </tr>
                                                        {
                                                            row.notes.length == 0?
                                                                <tr>
                                                                    <td style={{border:"1px solid #b0b0b0", textAlign:"right", padding:"3px"}} colSpan={4}>
                                                                        هیچ یادداشتی ثبت نشده است
                                                                    </td>
                                                                </tr>
                                                            :<></>
                                                        }
                                                        {
                                                            row.notes.map((n, nInd)=>{
                                                                return(
                                                                    <tr>
                                                                        <td style={{border:"1px solid #b0b0b0", textAlign:"right", padding:"3px"}}>{n.comment}</td>
                                                                        <td style={{border:"1px solid #b0b0b0", textAlign:"center", padding:"3px", color:n.zarib==1?"rgba(20, 151, 20, 1)":"#F00"}}>{n.effectScore}</td>
                                                                        <td style={{border:"1px solid #b0b0b0", padding:"3px"}}>{createEditButton(row.student, n.noteNo, n.effectScore, n.zarib, n.comment)}</td>
                                                                        <td style={{border:"1px solid #b0b0b0", padding:"3px"}}>{createDeleteButton(row.student, n.noteNo)}</td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                        <tr style={{}}>
                                                            <td style={{ textAlign:"center", padding:"3px"}}>جمع کل</td>
                                                            <td style={{border:"1px solid #b0b0b0", textAlign:"center", padding:"3px", width:"40px", color:row.zarib==1?"rgba(20, 151, 20, 1)":"#F00"}}>{row.effectScoreSum}</td>
                                                            <td style={{textAlign:"right", padding:"3px", width:"40px"}}>&nbsp;</td>
                                                            <td style={{textAlign:"right", padding:"3px", width:"40px"}}>&nbsp;</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        :<></>
                                    }
                                    </>
                                    )
                                })
                            }
                            <tr><td colSpan={5}>&nbsp;</td></tr>
                        </tbody>
                    </table>

                </>
            }

        </Dialog>

        {
        noteFormVisible?
        <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            header="ثبت یادداشت" modal className="p-fluid" footer={() => noteDialogFooter()} onHide={() => setNoteFormVisible(false)}>
            <table style={{marginTop:"10px", width:"100%"}}>
            <tbody>
                <tr>
                    <td style={{paddingTop:"10px"}}>
                        {student.firstname + " " + student.lastname}
                    </td>
                </tr>
                <tr>
                    <td style={{paddingTop:"20px"}}>
                        <FloatLabel>
                            <InputText value={comment} onChange={(e)=>{onInputChange(e, "comment")}}keyfilter="" maxLength={200} className="p-inputtext-lg" style={{width:"100%", textAlign:"right", direction:"rtl"}} />
                            <label htmlFor="username">شرح</label>
                        </FloatLabel>
                    </td>
                </tr>
                <tr>
                    <td style={{paddingTop:"10px"}}>
                        <div className="flex align-items-center" style={{marginTop:"3px"}}>
                            <Checkbox inputId="chk1" onChange={(e)=>{onCheckboxChange(e, "positive")}} checked={scoreState == 1} />
                            <label htmlFor="chk1" className="ml-2"> &nbsp;نمره مثبت دارد</label>
                        </div>                
                        
                    </td>
                </tr>
                <tr>
                    <td style={{paddingTop:"3px"}}>
                        <div className="flex align-items-center" style={{marginTop:"3px"}}>
                            <Checkbox inputId="chk2" onChange={(e)=>{onCheckboxChange(e, "negative")}} checked={scoreState == 2} />
                            <label htmlFor="chk2" className="ml-2"> &nbsp;نمره منفی دارد</label>
                        </div>                
                        
                    </td>
                </tr>
                <tr>
                    <td style={{paddingTop:"3px"}}>
                        <div className="flex align-items-center" style={{marginTop:"3px"}}>
                            <Checkbox inputId="chk3" onChange={(e)=>{onCheckboxChange(e, "none")}} checked={scoreState == 3} />
                            <label htmlFor="chk3" className="ml-2"> &nbsp;اثر نمره ای ندارد</label>
                        </div>                
                        
                    </td>
                </tr>
                <tr>
                    <td style={{paddingTop:"20px"}}>
                        <FloatLabel>
                            <InputText value={scoreStr} onChange={(e)=>{onInputChange(e, "score")}} keyfilter={"num"} maxLength={5} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                            <label htmlFor="username">نمره</label>
                        </FloatLabel>
                    </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
            </tbody>
            </table>

        </Dialog>
        :
        <></>
        }
        
      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
        <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
        </>
    )
};

export default TeacherNoteSave;